/**
 * JS pro automatické otevírání/zavírání BS modalu. Parametry otevírání modalu nastavujeme pomocí data- atributů:
 *
 * <div class="modal"
 *  data-modal-autoshow-delay="" POČET VTEŘIN DO AUTOMATICKÉHO OTEVŘENÍ OKNA (NULA = OTEVŘENÍ PO NAČTENÍ STRÁNKY)
 *  data-modal-autoclose-delay="" POČET VTEŘIN DO AUTOMATICKÉHO ZAVŘENÍ OKNA (BEZ PARAMETRU = OKNO SE AUTOMATICKY NEZAVÍRÁ)
 *  data-modal-show-on-leave-delay="" POČET VTEŘIN DO ZAPNUTÍ EVENTU ONMOUSELEAVE, KTERÝ OTEVŘE OKNO PŘI ODCHODU ZA STRÁNKY (BEZ PARAMETRU = EVENT SE NEZAPÍNÁ)
 *  data-modal-cookie="" NÁZEV COOKIE, KTERÁ SE MÁ NASTAVIT PO OTEVŘENÍ OKNA (BEZ PARAMETRU = NIC SE NENASTAVUJE)
 *  data-modal-cookie-expiration="" ČAS EXPIRACE COOKIE VE DNECH
 * >
 *
 * Modal zavřeme po ajax požadavku, posláním payload->hideModal = '#html-id-modalu'
 */

import { setCookie } from '../../../layout-common/js/parts/utils';
import { isSelectorValid } from '../../../../../_shared/js/utils/isSelectorValid';

// Inicializce modalu po načtení stránky nebo po vrácení snippetů
// Pokud nastavíme data-autoshow-delay="vteřiny", tak se modal automaticky otevře
function initModal(element) {
	let modals = element.querySelectorAll('.modal');

	modals.forEach((modalEl) => {
		let shown = false;
		let dataset = modalEl.dataset;
		let openDelay = parseInt(dataset.modalAutoshowDelay) * 1000;
		let closeDelay = parseInt(dataset.modalAutocloseDelay) * 1000;
		let showOnLeaveDelay = parseInt(dataset.modalShowOnLeaveDelay) * 1000;
		let cookie = dataset.modalCookie;
		let modalCookieExpiration = parseInt(dataset.modalCookieExpiration) * 86400; // dny

		if (isNaN(openDelay)) {
			return;
		}

		const modal = new window.Modal(modalEl);
		setTimeout(() => {
			if (shown === true) {
				return;
			}

			modal.show();
			shown = true;

			if (typeof cookie !== 'undefined' && modalCookieExpiration > 0) {
				setCookie(cookie, 1, modalCookieExpiration);
			}
		}, openDelay);

		// Existuje-li parametr data-modal-autoclose-delay
		// Nastavíme časovač pro zavření okna
		if (!isNaN(closeDelay)) {
			setTimeout(
				function () {
					modal.hide();
				},
				(!isNaN(openDelay) ? openDelay : 0) + closeDelay
			);
		}

		// Existuje-li parametr data-modal-show-on-leave-delay,
		// po uplnutí času nastavíme event pro otevření okna
		// při vyjetí myší mimo obrazovku
		if (!isNaN(showOnLeaveDelay)) {
			setTimeout(function () {
				document.addEventListener('mouseleave', (event) => {
					if (
						shown === false &&
						(event.clientY <= 0 ||
							event.clientX <= 0 ||
							event.clientX >= window.innerWidth ||
							event.clientY >= window.innerHeight)
					) {
						modal.show();
						shown = true;

						if (typeof cookie !== 'undefined' && modalCookieExpiration > 0) {
							setCookie(cookie, 1, modalCookieExpiration);
						}
					}
				});
			}, showOnLeaveDelay);
		}

		modalEl.addEventListener('hide.bs.modal', (event) => {
			// Pokud na modal nastavíme atribut data-modal-data-layer-on-close-outclick='{ "event": "abc", "param": "yxz" }'
			// dojde při zavření k odeslání dat do GTM
			// Pokud ale klikneme na close button, tak se data do GTM neodesílají - musíme nastavit data-data-layer-on-click na tlačítko zvlášť
			// Většinou chceme trackovat zavření modalu kliknutím mimo modal, nebo zavření modalu pomocí close buttonu
			if (
				!document.activeElement.classList.contains('btn-close') &&
				event.target.dataset.modalDataLayerOnCloseOutclick
			) {
				try {
					let data = JSON.parse(event.target.dataset.modalDataLayerOnCloseOutclick);

					window.dataLayer.push(data);
				} catch (e) {
					return;
				}
			}
		});
	});
}

// Automatické otevření Bs Modalu podle hash v url adrese
function openModalFromHash() {
	const hash = window.location.hash;

	if (hash && isSelectorValid(hash)) {
		const modalEl = document.querySelector(hash);
		if (modalEl && modalEl.classList.contains('modal')) {
			const bootstrapModal = window.Modal.getOrCreateInstance(modalEl);

			bootstrapModal.show();
		}
	}
}

export default function () {
	$.nette.ext('bs-modal', {
		init: function () {
			initModal(document);
			openModalFromHash();

			this.ext('snippets', true).after(($el) => {
				if ($el.get(0)) {
					initModal($el.get(0));
				}
			});
		},
		success: function (payload) {
			if (!payload.hideModal) {
				return;
			}

			const modalEl = document.querySelector(payload.hideModal);
			if (modalEl && modalEl.classList.contains('modal')) {
				const bootstrapModal = window.Modal.getOrCreateInstance(modalEl);

				bootstrapModal.hide();
			}
		}
	});

	window.addEventListener('hashchange', openModalFromHash);
}
